import { FoodDto } from "../api";
import { FoodUnit } from "./foodUnit";

export type BaseUnit = FoodDto["baseUnit"];

export default interface Food extends Omit<FoodDto, "foodUnits"> {
  foodUnits: FoodUnit[];
}

export const initialFood: Food = {
  id: -1,
  defaultPurchaseId: -1,
  baseUnit: "G",
  description: "",
  fat: 0,
  carbs: 0,
  protein: 0,
  kcal: 0,
  foodUnits: [],
  availabilities: [],
  purchaseRelevant: true,
  vendor: "",
  canBeDeleted: true,
  fromDish: false,
};
